<template>
    <form class="CreateEntryForm" v-on:submit.prevent="onFormSubmit" novalidate>
        <div class="row">
            <label class="sr-only" for="createEntryFormUrlInput">Url</label>
            <div class="input-group col-12 col-sm pr-sm-0 mr-sm-2 mb-2 mb-md-0">
                <input type="text"
                       class="form-control"
                       v-bind:class="{'is-invalid': context.validationErrorMessage}"
                       id="createEntryFormUrlInput"
                       placeholder="Save a URL"
                       v-model="url"
                       ref="input"
                       :disabled="disabled || currentState.matches('submitting')" />

                <div class="invalid-feedback"
                     v-bind:class="{'d-block': context.validationErrorMessage}">
                    {{context.validationErrorMessage}}
                </div>
            </div>
            <div class="col-12 col-sm-auto pl-sm-0">
                <b-button
                    v-bind:class="{'btn-block': $mq === 'xs' || $mq === 'sm'}"
                    ref="button"
                    variant="primary"
                    class="d-md-block"
                    :disabled="disabled || currentState.matches('submitting')"
                    type="submit"
                    style="min-width: 59.5px;"
                >
                            <span
                                v-if="currentState.matches('validating')
                                || currentState.matches('submitting')"
                                class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                    {{ currentState.matches('editing') ? 'Save' : '' }}
                </b-button>
            </div>
        </div>
    </form>
</template>

<script>
    import isUrl from "is-url";
    import {createCreateEntryFormMachine} from "./CreateEntryFormMachine";
    import {interpret} from "xstate";
    import {XSTATE_DEBUG_ENABLED} from "../../../constants.js";

    export default {
        name: "CreateEntryForm",

        props: [
            "execCreateEntryRequest",
            "onSubmitSuccess",
            "disabled"
        ],

        created() {
            this.formService
                .onTransition((state) => {
                    this.currentState = state;
                    this.context = state.context;
                    switch (state.event.type) {
                        case 'done.invoke.submit': {
                            this.$emit('entryCreated', state.event.data);
                            this.url = null;
                            this.focusInput();
                            break;
                        }
                        case 'error.platform.validating': {
                            this.focusInput();
                            break;
                        }
                    }
                })
                .start();
        },

        /*
         * The component's data.
         */
        data() {
            const createEntryFormMachine = createCreateEntryFormMachine().withConfig({
                services: {
                    execCreateEntryRequest: async (ctx, event) => {
                        const url = event.data;
                        return this.execCreateEntryRequest({ url });
                    }
                }
            });
            return {
                formService: interpret(createEntryFormMachine, {
                    devTools: XSTATE_DEBUG_ENABLED
                }),
                currentState: createEntryFormMachine.initialState,
                context: createEntryFormMachine.context,
                url: null,
                validationErrors: [],
                errors: []
            };
        },

        mounted() {
            this.$nextTick(() => {
                this.readClipboard();
            });
        },

        methods: {
            onFormSubmit(e) {
                this.formService.send({ type: 'SUBMIT', url: this.url });
            },

            onErrorDismiss(index, type) {
                if (type === 'technical') {
                    this.errors.splice(index, 1);
                } else {
                    this.validationErrors.splice(index, 1);
                }
            },

            focusInput() {
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
            },

            focusButton() {
                this.$nextTick(() => {
                    this.$refs.button.focus();
                });
            },

            readClipboard() {
                navigator?.clipboard?.readText()
                    .then(text => {
                        text = text.trim();
                        if (text && isUrl(text)) {
                            this.url = text;
                            this.focusButton();
                        } else {
                            this.focusInput();
                        }
                    })
                    .catch(err => {
                        console.error('Failed to read clipboard contents: ', err);
                        this.focusInput();
                    });
            }
        },
    }
</script>

<style scoped>

</style>
